$(document).on('mapsLoaded', function() {

    window.UserMarker = function(options) {
        let marker = this
        this.options = $.extend({}, options);
        this.div = $('<div class="user-marker"/>');
        if (this.options.position) this.setPosition(marker.options.position);

        marker.watchID = navigator.geolocation.watchPosition(position => {
            if (position.coords) {
                marker.animatePosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                })
            }
        });
    }

    UserMarker.prototype = Object.create(window.Marker.prototype);

    UserMarker.prototype.destroy = function () {
        this.setMap(null)
        if (this.watchID) navigator.geolocation.clearWatch(this.watchID);
    }
});
